module.exports = __webpack_public_path__ + "img/image_understanding.a9ee1831.svg";